







































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import StoreSuketPemeriksaanGigiMulut from "@/store/modules/SuketPemeriksaanGigiMulut";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import { storeDokter } from "@/store/modules/dokter";
import { SuketBaseWithRelationship } from "@/types/suket_pemeriksaan_gigi_mulut";

import pdf from "vue-pdf";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    pdf,
  },
})
export default class SuketPemeriksaanGigiMulutTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["03", "2I", "1A", "1B", "1C", "1D", "1E"];
  suketSvc = new CommonSuket(EnSuketCategory.PemeriksaanGigiMulut);
  suketStore = StoreSuketPemeriksaanGigiMulut;

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.PemeriksaanGigiMulut, this.dataSuket.id)
      : null;
  }

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  umur = getAge(formatDMYDate(this.pasien.tgl_lahir)).toString().concat(" Th");
  surat_date = new Date();
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alamat_type = "ktp";
  status_gigi = null;
  jaringan_lunak = null;
  ohi_s = null;
  rencana_tindakan = null;
  kesimpulan = null;
  catatan = null;
  keperluan_surat = null;
  validasi = [(v) => !!v || "*Kolom ini harus diisi"];
  saving = false;
  loadedRatio = 0;

  mounted() {
    this.fillFromData(this.dataSuket);
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get jenisKelamin() {
    if (this.pasien.jk === "L") return "Laki-laki";
    if (this.pasien.jk === "P") return "Perempuan";
    return this.pasien.jk || "-";
  }

  get alamatOptions() {
    const opts = [
      {
        id: "ktp",
        name: this.pasien.alamat,
        category: "Alamat KTP",
      },
    ];

    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili",
      });
    }

    return opts;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        status_gigi: this.status_gigi,
        jaringan_lunak: this.jaringan_lunak,
        ohi_s: this.ohi_s,
        rencana_tindakan: this.rencana_tindakan,
        kesimpulan: this.kesimpulan,
        catatan: this.catatan,
        keperluan_surat: this.keperluan_surat,
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id,
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  fillFromData(val: SuketBaseWithRelationship) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.umur = val.pasien?.umur_th || this.umur;
      this.alamat_type = val.content.alamat_type;
      this.status_gigi = val.content.status_gigi;
      this.jaringan_lunak = val.content.jaringan_lunak;
      this.ohi_s = val.content.ohi_s;
      this.rencana_tindakan = val.content.rencana_tindakan;
      this.kesimpulan = val.content.kesimpulan;
      this.catatan = val.content.catatan;
      this.keperluan_surat = val.content.keperluan_surat;
      this.surat_date = val.surat_date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");
      this.alamat_type = "ktp";
      this.status_gigi = null;
      this.jaringan_lunak = null;
      this.ohi_s = null;
      this.rencana_tindakan = null;
      this.kesimpulan = null;
      this.catatan = null;
      this.keperluan_surat = null;
      this.surat_date = new Date();
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
    }
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? this.suketSvc.update(this.dataSuket.id, this.input)
        : this.suketSvc.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.showSignatureModal();
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          StoreSuketPemeriksaanGigiMulut.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.expandInput = false;
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketBaseWithRelationship) {
    this.fillFromData(val);
  }
}
